import { ComponentType, ReactNode } from 'react';
import { Link } from '@tanstack/react-router';
import styled from 'styled-components';

import { APP_MIN_WIDTH } from 'constants/layout';

type TNavLinkProps = {
  to: string;
  activeOptions?: { exact?: boolean };
  className?: string;
  children?: ReactNode;
};
const NavLink = Link as unknown as ComponentType<TNavLinkProps>;

export const StyledShell = styled.div`
  display: flex;
  min-height: 100vh;
  /* Desktop-only floor. Narrower than this, the page pans instead of crushing. */
  min-width: ${APP_MIN_WIDTH}px;
`;

export const StyledSidebar = styled.aside`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.l}px;
  width: 224px;
  flex-shrink: 0;
  padding: ${({ theme }) => theme.spacing.l}px ${({ theme }) => theme.spacing.m}px;
  background-color: ${({ theme }) => theme.colors.backgroundSecondary};
  border-right: 1px solid ${({ theme }) => theme.colors.borderSubtle};
`;

export const StyledBrand = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing.s}px;
  padding: 0 ${({ theme }) => theme.spacing.s}px;
  font-family: ${({ theme }) => theme.fonts.bold};
  font-weight: 700;
  font-size: ${({ theme }) => theme.fontSizes.l}px;
  color: ${({ theme }) => theme.colors.textPrimary};
`;

export const StyledLogoMark = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 26px;
  height: 26px;
  border-radius: ${({ theme }) => theme.borderRadius.s}px;
  background: linear-gradient(135deg, ${({ theme }) => theme.colors.primary}, #6d5efc);
  color: ${({ theme }) => theme.colors.onPrimary};
  font-size: ${({ theme }) => theme.fontSizes.m}px;
  font-weight: 700;
`;

export const StyledNav = styled.nav`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.xs}px;
`;

export const StyledNavItem = styled(NavLink)`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing.sm}px;
  padding: ${({ theme }) => theme.spacing.s}px ${({ theme }) => theme.spacing.sm}px;
  border-radius: ${({ theme }) => theme.borderRadius.s}px;
  color: ${({ theme }) => theme.colors.textSecondary};
  font-family: ${({ theme }) => theme.fonts.semiBold};
  font-size: ${({ theme }) => theme.fontSizes.m}px;
  font-weight: 600;
  text-decoration: none;
  cursor: pointer;

  &:hover {
    background-color: ${({ theme }) => theme.colors.surfaceHover};
    color: ${({ theme }) => theme.colors.textPrimary};
  }

  &[data-status='active'] {
    background-color: ${({ theme }) => theme.colors.surfaceHover};
    color: ${({ theme }) => theme.colors.textPrimary};
    box-shadow: inset 2px 0 0 ${({ theme }) => theme.colors.primary};
  }
`;

export const StyledContent = styled.main`
  flex: 1;
  min-width: 0;
`;
